export const isBenchmarkEnabledForCountry = (countryCode: string | undefined): boolean => {
  if (!countryCode) return false;
  
  const enabledCountries = process.env.REACT_APP_BENCHMARK_ENABLED_COUNTRIES;
  if (!enabledCountries) return false;
  
  const allowedCountries = enabledCountries.split(",").map(c => c.trim().toUpperCase());
  return allowedCountries.includes(countryCode.toUpperCase());
};